<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 sm6 class="pa-1">
      <v-text-field
        label="Enter in SLUG for the conf (jconfdev2020)"
        hint="jconfdev2020"
        persistent-hint
        outline
        class="shrink"
        v-model="confSlug"
      ></v-text-field>

      <v-text-field
              label="Twitter background image URL"
              hint="http://tools.connectevents.io/jconfdevtwitter.png"
              persistent-hint
              outline
              v-model="twitterPromoImage"
      ></v-text-field>
      <v-text-field
          label="Instagram background image URL"
          hint="http://tools.connectevents.io/jconfdevtwitter.png"
          persistent-hint
          outline
          v-model="instagramPromoImage"
      ></v-text-field>
        <v-radio-group v-model="bgimage">
          <v-radio label="Twitter/LI" value="twitter"></v-radio>
          <v-radio label="Instagram" value="instagram"></v-radio>
        </v-radio-group>
      <v-text-field
          label="font color"
          hint="#ffffff"
          persistent-hint
          outline
          v-model="fontcolor"
      ></v-text-field>
      <v-textarea
              label="Promo text as HTML"
              persistent-hint
              outline
              height="250"
              v-model="promoText"
      ></v-textarea>
        </v-flex>
    </v-layout>

    <v-btn color="primary"  @click="reloadata">Reload JSON data</v-btn>
    <v-btn color="primary"  @click="generateAllTwitterImages">Generate all twitter images</v-btn>
    <v-btn color="primary"  @click="generateAllInstagramImages">Generate all instagram images</v-btn>
    <v-layout>
      <v-flex xs6>
        <div v-for="person in persons" :key="person.id">

          <div v-if="bgimage === 'twitter'">
            <TwitterCard :person="person" :promoImage="promoImage()" :promoText="promoText" :fontcolor="fontcolor"></TwitterCard>
          </div>
          <div v-else-if="bgimage === 'instagram'">
            <InstagramCard :person="person" :promoImage="promoImage()" :promoText="promoText" :fontcolor="fontcolor"></InstagramCard>
          </div>

        </div>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import TwitterCard from "./TwitterCard";
import persons from "../data/sessionize.json";
import axios from "axios";
import InstagramCard from "./InstagramCard.vue";

export default {
  components: {InstagramCard, TwitterCard },
  data: () => ({
    confSlug: "https://sessionize.com/api/v2/gw8kv3zh/view/Speakers",
    persons: persons.persons,
    twitterPromoImage: "http://tools.connectevents.io/ct24-twitter.png",
    instagramPromoImage: "http://tools.connectevents.io/ct-insta-background.png",
    promoText: `<div>Check out:<br>,
{{title}}
<br><br>
with @{{twitterHandle}}
<br><br>
at connect.tech
@connect_js
<br>November 18, 2024
</div>`,
    bgimage: "twitter",
    fontcolor: "#ffffff"
  }),
  methods: {
    reloadata() {
      console.log("reloadata");
      let promoEventsURL = `${this.confSlug}`
      axios.get(promoEventsURL).then(response => (this.persons = response.data));
    },
    generateAllTwitterImages() {
      this.$root.$emit("generateAllTwitterImages");
    },
    generateAllInstagramImages() {
      this.$root.$emit("generateAllInstagramImages");
    },
    promoImage() {
      if (this.bgimage === "twitter")
        return  this.twitterPromoImage
      else
        return  this.instagramPromoImage
    }
  },
  watch: {
    bgimage: function(newValue, oldValue) {
      console.log(newValue)
    }
  }
};
</script>

<style></style>
